import React, { useState, useEffect } from 'react';
import Select, { createFilter } from 'react-select';

const SellerSelect = ({ options, value, onChange, placeholder, styles, validate, validateMsg, topTitle }) => {
    const [isClearable, setIsClearable] = useState(true);

    const mappedOptions = options.map(option => ({
        value: option.id,
        label: `${option.firstname} ${option.lastname}` // Assuming sellers have firstname and lastname
    }));

    const selectedOption = mappedOptions.find(option => option.value === value);

    const stylesError = {
        control: (provided, state) => ({
            ...provided,
            border: state.isFocused ? '1px solid rgb(225 29 72)' : '1px solid rgb(225 29 72)',
            boxShadow: state.isFocused ? 'none' : 'none',
            '&:hover': {
                border: state.isFocused ? '1px solid rgb(225 29 72)' : '1px solid rgb(225 29 72)',
            },
            minHeight: '35px',
            width: '100%',
            cursor: 'pointer',
            borderRadius: '5px',
        }),
    };

    const tileStyles = {
        position: 'absolute',
        fontSize: '11px',
        fontWeight: '500',
        color: 'var(--muted-text-color)',
        lineHeight: 1,
        marginBottom: '4px',
        top: '-6px',
        zIndex: '1',
        left: '8px',
        padding: '0 3px',
        background: '#fff',
    };

    const tileStylesError = {
        position: 'absolute',
        fontSize: '11px',
        fontWeight: '500',
        color: 'rgb(225, 29, 72)',
        lineHeight: 1,
        marginBottom: '4px',
        top: '-6px',
        zIndex: '1',
        left: '8px',
        padding: '0 3px',
        background: '#fff',
    };

    return (
        <div style={{ width: '100%', position: 'relative' }}>
            <Select
                styles={validate ? { ...styles, ...stylesError } : styles}
                options={mappedOptions}
                value={selectedOption}
                onChange={onChange}
                placeholder={placeholder}
                filterOption={createFilter({ ignoreAccents: false })}
                isClearable={isClearable}
            />

            {topTitle && (
                <div style={validate ? tileStylesError : tileStyles}>
                    {placeholder}
                </div>
            )}

            {validate && validateMsg && (
                <div style={{ color: 'rgb(225, 29, 72)', fontSize: '12px' }}>
                    {validateMsg}
                </div>
            )}
        </div>
    );
};

export default SellerSelect;